import { cn } from "@/lib/utils";

/** Mono overline label with optional index / coordinate marker. */
export const SectionLabel = ({ children, marker, className, tone = "warm" }) => {
  const color = tone === "light" ? "text-[#F7F5F0]/60" : "text-[#8A9098]";
  return (
    <div className={cn("flex items-center gap-3", className)}>
      {marker && (
        <span className={cn("font-mono-ss text-[0.7rem] tracking-widest", color)}>{marker}</span>
      )}
      <span className="h-px w-8 bg-current opacity-30" aria-hidden />
      <span className={cn("ss-overline", color)}>{children}</span>
    </div>
  );
};

export default SectionLabel;
